/** French UI strings — dot-path keys for `t('section.key')`. */
export default {
  nav: {
    dashboard: 'Tableau de bord',
    courses: 'Cours',
    groups: 'Groupes',
    students: 'Étudiants',
    trainers: 'Formateurs',
    sessions: 'Sessions',
    certifications: 'Certifications',
    evaluations: 'Évaluations',
    schedule: 'Emploi du temps',
    classrooms: 'Salles',
    payments: 'Paiements',
    benefits: 'Bénéfices',
    reports: 'Rapports',
    settings: 'Paramètres',
  },

  layout: {
    logout: 'Déconnexion',
    menuTitle: 'Menu',
    menuCloseSr: 'Fermer',
    mainNavAria: 'Navigation principale',
    overlayCloseNav: 'Fermer la navigation',
    mobileNavPrimary: 'Navigation principale',
  },

  header: {
    brandLine: 'École de formation',
    searchPlaceholder: 'Rechercher une page, un cours, un étudiant…',
    searchSrOnly: 'Rechercher',
    openMenuSr: 'Ouvrir le menu',
    toggleMenuSr: 'Basculer le menu',
    themeLightAria: 'Passer au thème clair',
    themeDarkAria: 'Passer au thème sombre',
    changeLangAria: 'Changer la langue',
    notificationsSr: 'Notifications',
    notificationsTitle: 'Notifications',
    notificationsCloseBackdrop: 'Fermer les notifications',
    notificationsEmpty: 'Aucune notification',
    userMenuSr: 'Menu utilisateur',
    closeUserMenu: 'Fermer le menu utilisateur',
    fallbackUserName: 'Utilisateur',
    fallbackUserRole: 'Administrateur',
  },

  login: {
    title: 'Se connecter',
    formSubtitle: 'Accédez à votre espace de gestion pédagogique.',
    emailLabel: 'Email',
    passwordLabel: 'Mot de passe',
    submit: 'Se connecter',
    loading: 'Connexion…',
    errorGeneric: 'Connexion impossible. Vérifiez vos identifiants ou réessayez plus tard.',
    platformLabel: 'Plateforme de formation',
    heroTitle: 'Pilotez votre école de formation en toute simplicité',
    heroSubtitle: 'Cours, inscriptions, paiements et rapports — tout est centralisé dans un seul outil.',
    feature_courses: 'Gestion des cours et des groupes',
    feature_reports: 'Suivi financier et rapports en temps réel',
    feature_secure: 'Accès sécurisé réservé au personnel',
    secureAccess: 'Accès sécurisé au personnel',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    footerNote: 'Réservé au personnel autorisé de l\'établissement.',
    trustBadge: 'Espace sécurisé · Personnel autorisé',
  },

  dashboard: {
    title: 'Tableau de bord',
    description: 'Vue synthétique de l’activité pédagogique, des revenus et de l’occupation.',
    newCourse: 'Nouveau cours',
    statStudents: 'Étudiants Actifs',
    statCourses: 'Cours en cours',
    statRevenue: 'Revenus du mois',
    statOccupancy: "Taux d'occupation",
    seeDetails: 'Voir les détails →',
    chartDistributionTitle: 'Répartition par type de formation',
    allCoursesLink: 'Tous les cours',
    shareOfCourses: '{pct}% des formations',
    revenueTitle: 'Revenus mensuels',
    benefitsLink: 'Bénéfices',
    montantLegend: 'Montant',
    pieDistributionTitle: 'Distribution des formations',
    manageCourses: 'Gérer les cours',
    coursesCount: '{n} cours',
    countLegend: 'Nombre',
    upcomingTitle: 'Prochains cours',
    upcomingSubtitle: 'Sessions planifiées à venir',
    seeAll: 'Voir tout',
    loadingCourses: 'Chargement des cours…',
    emptyUpcomingTitle: 'Aucun cours à venir',
    emptyUpcomingBody:
      'Planifiez une session depuis les cours ou l’emploi du temps pour la voir ici.',
    scheduleCourse: 'Planifier un cours',
    colCourse: 'Cours',
    colStartDate: 'Date de début',
    colStudents: 'Étudiants',
    colRoom: 'Salle',
    colActions: 'Actions',
    viewDetails: 'Voir les détails',
    occupancyTitle: "Taux d'occupation hebdomadaire des salles",
    manageRooms: 'Gérer les salles',
    occupancyLegend: "Taux d'occupation",
    noCourseData: 'Aucune donnée',
    noTitleCourse: 'Cours sans nom',
    undefinedRoom: 'Salle non définie',
    weekdaysShort: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    monthsFallback: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul'],
    currencyDa: 'DA',
    pieTooltipCourses: '{n} cours',
    quickActions: 'Accès rapide',
    revenueSubtitle: 'Évolution des encaissements sur la période',
    pieSubtitle: 'Répartition des formations actives',
    occupancySubtitle: 'Suivi hebdomadaire de l\'utilisation des salles',
    studentsShort: 'étud.',
  },

  settingsPage: {
    title: 'Paramètres',
    description:
      "Configuration de l'établissement, des cours, des salles et de la facturation.",
    sections: 'Sections',
    resources: 'Ressources',
    mobileApp: 'Application mobile',
    languages: 'Langues',
    helpCenter: "Centre d'aide",
    helpGuide: "Guide d'utilisation",
    contactSupport: 'Contacter le support',
    tabGeneral: 'Général',
    tabNotifications: 'Notifications',
    tabSecurity: 'Sécurité',
    tabHours: 'Horaires',
    tabBilling: 'Facturation',
    tabCourses: 'Cours',
    tabClassrooms: 'Salles',
    tabTrainers: 'Formateurs',
    tabCertifications: 'Certificats',
    tabGeneralDesc: "Identité de l'établissement, coordonnées et logo",
    tabNotificationsDesc: 'Alertes email et rappels automatiques',
    tabSecurityDesc: 'Sessions, mots de passe et authentification',
    tabHoursDesc: "Horaires d'ouverture de l'établissement",
    tabBillingDesc: 'TVA, factures et conditions de paiement',
    tabCoursesDesc: 'Accès rapide à la gestion des formations',
    tabClassroomsDesc: 'Accès rapide à la gestion des salles',
    tabTrainersDesc: 'Commission formateurs (utilisée dans Bénéfices et Rapports)',
    tabCertificationsDesc: 'Modèles PDF utilisés sur la page Certificats',
    moduleRedirectNoticeTitle: 'Géré ailleurs dans l\'application',
    coursesRedirectTitle: 'Formations et programmes',
    coursesRedirectDesc: 'Les cours, tarifs, durées et groupes sont créés et modifiés sur la page Cours — pas ici.',
    coursesRedirectLink: 'Ouvrir la page Cours',
    coursesRedirectNotice: 'Cet onglet redirige vers le module principal. Les données affichées auparavant ici étaient des exemples statiques non enregistrés.',
    coursesBullet1: 'Créer et modifier les formations',
    coursesBullet2: 'Définir les tarifs et les sessions (groupes)',
    coursesBullet3: 'Assigner formateurs et salles',
    classroomsRedirectTitle: 'Salles et équipements',
    classroomsRedirectDesc: 'La liste des salles, capacités et équipements est gérée sur la page Salles.',
    classroomsRedirectLink: 'Ouvrir la page Salles',
    classroomsRedirectNotice: 'Les types de salles configurés ici n\'étaient pas sauvegardés. Utilisez la page Salles pour vos données réelles.',
    classroomsBullet1: 'Ajouter et modifier les salles',
    classroomsBullet2: 'Capacité et type de salle',
    classroomsBullet3: 'Équipements disponibles',
    trainersCommissionNoticeTitle: 'Commission active',
    trainersCommissionNotice: 'Ce pourcentage est utilisé en temps réel dans Bénéfices et Rapports pour calculer la part formateur / établissement.',
    trainersCommissionTitle: 'Commission des formateurs',
    trainersCommissionLabel: 'Pourcentage reversé aux formateurs',
    trainersCommissionHint: 'Appliqué automatiquement aux calculs financiers de l\'application.',
    trainersCommissionInvalid: 'Le pourcentage doit être entre 0 et 100',
    trainersCommissionUpdated: 'Commission mise à jour : {{rate}}%',
    trainersCommissionPreview: 'Aperçu sur un paiement de 55 000 DA',
    trainersPreviewPayment: 'Paiement étudiant',
    trainersPreviewTrainer: 'Part formateur ({{rate}}%)',
    trainersPreviewSchool: 'Part établissement ({{rate}}%)',
    trainersManageTitle: 'Profils et spécialités',
    trainersManageDesc: 'Les fiches formateurs, spécialités et affectations se gèrent sur la page Formateurs.',
    trainersManageLink: 'Ouvrir Formateurs',
  },

  trainersPage: {
    title: 'Formateurs',
    description: 'Gestion des formateurs et de leurs cours',
    newTrainer: 'Nouveau formateur',
    statTotal: 'Total des formateurs',
    statTotalHint: 'Dans votre annuaire',
    statCourses: 'Cours assignés',
    statCoursesHint: 'Liens formation–formateur',
    statSpecs: 'Spécialités',
    statSpecsHint: 'Domaines distincts',
    allSpecialties: 'Toutes les spécialités',
    specialityLabel: 'Spécialité',
    filterCountHint: 'Compte après recherche',
    searchSr: 'Rechercher un formateur',
    searchPlaceholder: 'Nom, email ou spécialité…',
    clearSearchAria: 'Effacer la recherche',
    filtersActive: 'Filtres actifs',
    resetFilters: 'Réinitialiser',
    selectedSingle: '1 formateur sélectionné',
    selectedPlural: '{n} formateurs sélectionnés',
    deselectAll: 'Tout désélectionner',
    deleteSelected: 'Supprimer ({n})',
    emptyTitle: 'Aucun formateur à afficher',
    emptyBody:
      'Essayez une autre recherche, élargissez le filtre de spécialité avec « Réinitialiser », ou ajoutez un nouveau formateur.',
    clearFiltersBtn: 'Effacer filtres et recherche',
    addTrainer: 'Ajouter un formateur',
    listHeading: 'Liste des formateurs',
    resultsSingular: 'résultat',
    resultsPlural: 'résultats',
    rangeOn: 'plage',
    onTotal: 'sur',
    perPage: 'par page',
    srSelection: 'Sélection',
    selectPageAria: 'Sélectionner tout sur cette page',
    colTrainer: 'Formateur',
    colContact: 'Contact',
    colSpecialty: 'Spécialité',
    colAssignedCourses: 'Cours assignés',
    colActions: 'Actions',
    experienceYearsSingular: "an d'expérience",
    experienceYearsPlural: "ans d'expérience",
    notSpecified: 'Non spécifié',
    noAssignedCourses: 'Aucun cours assigné',
    selectTrainerSr: 'Sélectionner {name}',
    titleView: 'Voir les détails',
    titleEdit: 'Modifier',
    titleDelete: 'Supprimer',
    paginationLabel: 'Pagination',
    prev: 'Précédent',
    next: 'Suivant',
    paginationSummary:
      'Affichage {range} sur {total} · page {page} sur {pages}',
    backToList: 'Retour à la liste',
    loading: 'Chargement…',
    confirmDeleteTrainer: 'Êtes-vous sûr de vouloir supprimer ce formateur ?',
    deleteErrorGeneric: 'Une erreur est survenue lors de la suppression',
    bulkDeleteError: 'Erreur lors de la suppression des formateurs',
    bulkDeleteTitle: 'Confirmer la suppression',
    bulkDeleteAskOne:
      'Êtes-vous sûr de vouloir supprimer ce formateur ? Cette action est irréversible.',
    bulkDeleteAskMany:
      'Êtes-vous sûr de vouloir supprimer {n} formateurs ? Cette action est irréversible.',
  },

  studentsPage: {
    description: 'Gestion des étudiants et de leurs inscriptions',
    newStudent: 'Nouvel étudiant',
    statRegisteredTitle: 'Étudiants enregistrés',
    statRegisteredHint: 'Fiche créée dans le système',
    statActiveTitle: 'Actifs',
    statActiveHint: 'Statut « actif »',
    statNoCourseTitle: 'Sans formation',
    statNoCourseHint: 'Aucune formation liée à la fiche',
    tabAll: 'Tous les Étudiants',
    tabActive: 'Actifs',
    tabSuspended: 'Suspendus',
    tabInactive: 'Inactifs',
    tabNoCourse: 'Sans Formation',
    statusLabel: 'Statut',
    countAfterSearch: 'Compte après recherche',
    searchSrOnly: 'Rechercher un étudiant',
    searchPlaceholder: 'Nom, code ou email…',
    clearSearchAria: 'Effacer la recherche',
    filtersActive: 'Filtres actifs',
    resetFilters: 'Réinitialiser',
    selectedSingle: '1 étudiant sélectionné',
    selectedPlural: '{n} étudiants sélectionnés',
    deselectAll: 'Tout désélectionner',
    deleteSelected: 'Supprimer ({n})',
    emptyTitle: 'Aucun étudiant à afficher',
    emptyBody:
      'Essayez une autre recherche, élargissez le filtre statut avec « Réinitialiser », ou créez une nouvelle fiche étudiant.',
    clearFiltersBtn: 'Effacer filtres et recherche',
    addStudent: 'Ajouter un étudiant',
    listHeading: 'Liste des étudiants',
    resultsSingular: 'résultat',
    resultsPlural: 'résultats',
    rangeOn: 'plage',
    onTotal: 'sur',
    perPage: 'par page',
    srSelection: 'Sélection',
    selectAllPageAria: 'Sélectionner tout sur cette page',
    colStudent: 'Étudiant',
    colContact: 'Contact',
    colFormation: 'Formation',
    colStatus: 'Statut',
    colActions: 'Actions',
    noEnrollment: 'Sans inscription',
    groupNotFound: 'Groupe introuvable',
    enrollmentsCount: '{n} inscriptions',
    multipleEnrollments: 'Inscriptions multiples',
    statusActiveLbl: 'Actif',
    statusSuspendedLbl: 'Suspendu',
    statusInactiveLbl: 'Inactif',
    selectStudentSr: 'Sélectionner {name}',
    confirmDeleteStudent: 'Êtes-vous sûr de vouloir supprimer cet étudiant ?',
    deleteErrorGeneric: 'Une erreur est survenue lors de la suppression',
    bulkDeleteError: 'Erreur lors de la suppression des étudiants',
    bulkDeleteTitle: 'Confirmer la suppression',
    bulkDeleteAskOne:
      'Êtes-vous sûr de vouloir supprimer cet étudiant ? Cette action est irréversible.',
    bulkDeleteAskMany:
      'Êtes-vous sûr de vouloir supprimer {n} étudiants ? Cette action est irréversible.',
    paginationLabel: 'Pagination',
    prev: 'Précédent',
    next: 'Suivant',
    paginationSummary:
      'Affichage {range} sur {total} · page {page} sur {pages}',
    backToList: 'Retour à la liste',
    loading: 'Chargement…',
    loadingDetail: "Chargement des détails de l'étudiant...",
    notFoundMsg: 'Étudiant introuvable (ID: {id})',
    backToStudentsList: '← Retour à la liste des étudiants',
    detailNameMissing: 'Nom non renseigné',
    detailCodeMissing: 'Code non renseigné',
    detailPhoneLabel: 'Téléphone',
    detailEmailLabel: 'Email',
    detailJoinDateLabel: "Date d'inscription",
    detailStatusLabel: 'Statut',
    detailStatusUnknown: 'Inconnu',
    detailActiveEnrollmentsTitle: 'Inscriptions actives',
    detailNoActiveEnrollment: 'Aucune inscription active',
    detailBadgeActive: 'Actif',
    detailScheduleLabel: 'Horaires:',
    detailPeriodLabel: 'Période:',
    detailPeriodFrom: 'Du',
    detailPeriodTo: 'au',
    detailTrainerLabel: 'Formateur:',
    detailRoomLabel: 'Salle:',
    detailRoomUndefined: 'Non définie',
    detailEnrollmentLabel: 'Inscription:',
    notProvidedShort: 'Non renseigné',
    formTitleEdit: "Modifier l'étudiant",
    formTitleAdd: 'Ajouter un étudiant',
    formSectionPersonal: 'Informations personnelles',
    formFullName: 'Nom complet *',
    formEmail: 'Email *',
    formPhone: 'Téléphone *',
    formPhonePlaceholder: '+213 XXX XXX XXX',
    formStatus: 'Statut',
    formSectionAddress: 'Adresse',
    formStreet: 'Rue/Adresse',
    formStreetPlaceholder: '123 Rue de la République',
    formCity: 'Ville',
    formCityPlaceholder: 'Alger',
    formPostalCode: 'Code postal',
    formPostalPlaceholder: '16000',
    formState: 'Wilaya/État',
    formCountry: 'Pays',
    formSectionTraining: 'Formation actuelle',
    formBatchSelect: 'Groupe de cours',
    formBatchPlaceholder: 'Sélectionner un groupe',
    formBatchDetailsTitle: 'Détails du groupe:',
    formLblCourse: 'Cours:',
    formLblTrainer: 'Formateur:',
    formLblSchedule: 'Horaires:',
    formLblHours: 'Heures:',
    formLblPeriod: 'Période:',
    formLblPeriodSep: 'au',
    formLblSeats: 'Places:',
    formLblSeatsRemain: '{n} restantes',
    formLblRoom: 'Salle:',
    formLblStatus: 'Statut:',
    formJoinDate: "Date d'inscription",
    formBatchFullMark: 'COMPLET',
    formBatchPlacesAvail: '{n} places',
    formStatusFull: 'COMPLET',
    formStatusAlmostFull: 'PRESQUE COMPLET',
    formStatusFilling: 'SE REMPLIT',
    formStatusOpen: 'OUVERT',
    formPlacesParen: '{n} places',
    formAlertBatchNotFound: '❌ Erreur : groupe introuvable',
    formAlertBatchFull:
      '❌ Impossible d\'inscrire l\'étudiant !\n\nLe groupe « {batch} » est complet.\n\n📊 Capacité : {current}/{max} étudiants\n\n💡 Choisissez un autre groupe ou augmentez la capacité.',
    formAlertNoSpots:
      '❌ Aucune place disponible !\n\nLe groupe « {batch} » n\'a plus de places libres.\n\n📊 Places restantes : {spots}',
    formAlertEnrollmentSuccess:
      '✅ Inscription réussie !\n\n👤 Étudiant : {name}\n📚 Groupe : {batch}\n📊 Nouvelle capacité : {current}/{max}\n🎯 Places restantes : {remaining}',
    formAlertEnrollmentFailed:
      "❌ Erreur lors de l'inscription dans le groupe",
    deleteFailedShort: 'Échec de la suppression',
    bulkDeletePartialError:
      'Seulement {success}/{total} étudiants ont été supprimés',
  },

  trainerForm: {
    backToList: 'Retour à la liste',
    titleAdd: 'Ajouter un formateur',
    titleEdit: 'Modifier le formateur',
    previewAlt: 'Aperçu',
    photoSr: 'Choisir une photo',
    photoMaxError: 'La photo ne peut pas dépasser 5MB',
    photoFormats: "PNG, JPG jusqu'à 5MB",
    nameLabel: 'Nom complet*',
    codeLabel: 'Code formateur',
    phoneLabel: 'Téléphone*',
    emailLabel: 'Email',
    specialityLabel: 'Spécialité',
    statusLabel: 'Statut',
    joinDateLabel: "Date d'engagement",
    statusActive: 'Actif',
    statusInactive: 'Inactif',
    statusLeave: 'En congé',
    cancel: 'Annuler',
    submitAdd: 'Ajouter',
    submitUpdate: 'Mettre à jour',
    requiredName: 'Le nom est requis',
    requiredPhone: 'Le téléphone est requis',
    invalidEmail: 'Email invalide',
    saveError: "Une erreur est survenue lors de l'enregistrement des données",
  },

  trainerDetail: {
    notFound: 'Aucun formateur trouvé',
    backToList: 'Retour à la liste',
    phone: 'Téléphone',
    email: 'Email',
    speciality: 'Spécialité',
    joinDate: "Date d'engagement",
    notProvidedM: 'Non renseigné',
    notProvidedF: 'Non renseignée',
    edit: 'Modifier',
  },

  /** Shared table / actions labels used across pages */
  commonActions: {
    viewDetails: 'Voir les détails',
    edit: 'Modifier',
    delete: 'Supprimer',
    viewStudents: 'Voir les étudiants',
    editGroup: 'Modifier le groupe',
    view: 'Voir',
    previewPdf: 'Aperçu / PDF',
    exportPdf: 'Exporter PDF',
    print: 'Imprimer',
    toggleStatusSr: 'Cliquer pour modifier le statut',
    detailsSr: 'Détails',
    refreshData: 'Rafraîchir les données',
    prevYear: 'Année précédente (Shift+←)',
    nextYear: 'Année suivante (Shift+→)',
    prevMonth: 'Mois précédent (←)',
    nextMonth: 'Mois suivant (→)',
    today: "Aujourd'hui (Home)",
  },

  coursesPageTitle: 'Cours',
  groupsPageTitle: 'Groupes',
  studentsPageTitle: 'Étudiants',
  sessionsPageTitle: 'Sessions',
  certificationsPageTitle: 'Certifications',
  paymentsPageTitle: 'Paiements',
  classroomsPageTitle: 'Salles',
  schedulePageTitle: 'Emploi du temps',
  schedulePageLoadedEvents: '{n} événements chargés (temps réel)',
  benefitsPageTitle: 'Finances & revenus',
  reportsPageTitle: 'Rapports',
  evaluationsPageTitle: 'Évaluations',

  coursesPage: {
    title: 'Cours',
    description: 'Gestion des formations et des inscriptions',
    newCourse: 'Nouveau cours',
    statsTotalTitle: 'Total des cours',
    statsTotalHint: 'Dans votre catalogue',
    statsOpenTitle: 'Activement ouverts',
    statsOpenHint: 'Statut « en cours »',
    statsFilledTitle: 'Places occupées',
    statsFilledHint: 'Inscriptions enregistrées',
    tabAll: 'Tous les Cours',
    tabActive: 'En cours',
    tabPending: 'À venir',
    tabCompleted: 'Terminés',
    statusLabel: 'Statut',
    countAfterSearch: 'Compte après recherche',
    searchSrOnly: 'Rechercher un cours',
    searchPlaceholder: 'Nom, code ou formateur...',
    clearSearchAria: 'Effacer la recherche',
    filtersActive: 'Filtres actifs',
    resetFilters: 'Réinitialiser',
    selectedSingle: '1 cours sélectionné',
    selectedPlural: '{n} cours sélectionnés',
    deselectAll: 'Tout désélectionner',
    deleteBulk: 'Supprimer ({n})',
    confirmDeleteCourse: 'Êtes-vous sûr de vouloir supprimer ce cours ?',
    deleteError: 'Une erreur est survenue lors de la suppression',
    bulkDeleteError: 'Erreur lors de la suppression des cours',
    bulkDeleteAskOne:
      'Êtes-vous sûr de vouloir supprimer ce cours ? Cette action est irréversible.',
    bulkDeleteAskMany:
      'Êtes-vous sûr de vouloir supprimer {n} cours ? Cette action est irréversible.',
    bulkDeleteCancel: 'Annuler',
    bulkDeleteConfirm: 'Supprimer',
    emptyTitle: 'Aucun cours à afficher',
    emptyBody:
      'Essayez une autre recherche, changez l’onglet de statut ou ajoutez un nouveau cours.',
    clearFiltersBtn: 'Effacer filtres et recherche',
    listHeading: 'Liste des cours',
    resultsSingular: 'résultat',
    resultsPlural: 'résultats',
    rangeOn: 'plage',
    onTotal: 'sur',
    perPage: 'par page',
    srSelection: 'Sélection',
    selectAllPageAria: 'Sélectionner tout sur cette page',
    colCourse: 'Cours',
    colCode: 'Code',
    colTrainerCol: 'Formateur',
    colStatusCol: 'Statut',
    colStudentsCol: 'Étudiants',
    colStartCol: 'Début',
    colActions: 'Actions',
    paginationAria: 'Pagination',
    prevPage: 'Précédent',
    nextPage: 'Suivant',
    paginationSummary:
      'Affichage {range} sur {total} · page {page} sur {pages}',
    capacitySuffix: '{n} étudiants',
    batchTotalStudents:
      'Total : {n} étudiant{s}',
    batchPluralS: 's',
    batchPluralEmpty: '',
    noStudentYet: 'Aucun étudiant inscrit pour le moment',
    noStudentEnrolledTitle: 'Aucun étudiant inscrit',
    noStudentEnrolledBody: "Ce groupe n'a pas encore d'étudiants inscrits.",
    batchFormTitleEdit: 'Modifier le groupe',
    batchFormTitleNew: 'Créer un nouveau groupe',
    batchSubmitEdit: 'Modifier le groupe',
    batchSubmitCreate: 'Créer le groupe',
    trainerConflictAlert:
      "Il y a des conflits d'horaires avec ce formateur. Veuillez choisir un autre créneau ou formateur.",
    batchSaveError: "Erreur lors de l'enregistrement du groupe",
    confirmDeleteBatch: 'Êtes-vous sûr de vouloir supprimer ce groupe ?',
    courseFormAddTitle: 'Ajouter un cours',
    courseFormEditTitle: 'Modifier le cours',
    courseFormSubmitAdd: 'Ajouter',
    courseFormSubmitUpdate: 'Mettre à jour',
    bulkModalTitle: 'Confirmer la suppression',
    addCourseShortcut: 'Ajouter un cours',
    selectCourseRowAria: 'Sélectionner {name}',
    colPeriod: 'Période',
    colEnrollments: 'Inscriptions',
    trainerNotAssigned: 'Non assigné',
    trainerSpecialityMissing: 'Non spécifié',
    endsOnPrefix: 'au',
    detailBackToList: 'Retour à la liste',
    statusLblActiveRow: 'En cours',
    statusLblPendingRow: 'À venir',
    statusLblCompletedRow: 'Terminé',

    weekdays: {
      Monday: 'Lundi',
      Tuesday: 'Mardi',
      Wednesday: 'Mercredi',
      Thursday: 'Jeudi',
      Friday: 'Vendredi',
      Saturday: 'Samedi',
      Sunday: 'Dimanche',
    },

    batchLblGroupName: 'Nom du groupe',
    batchPlaceholderGroupSuffix: '{name} — Groupe A',
    batchLblDays: 'Jours de la semaine',
    batchLblStartTime: 'Heure de début',
    batchLblEndTime: 'Heure de fin',
    batchLblStartDateShort: 'Date de début',
    batchLblEndDateShort: 'Date de fin',
    optionalSuffix: 'optionnel',
    periodNotSet: 'Période non définie',
    batchLblTrainerShort: 'Formateur',
    batchSelectTrainer: 'Sélectionner un formateur',
    trainerFallbackNamed: 'Formateur {id}',
    batchLblMaxCapacity: 'Capacité maximale',
    batchLblRoomOptional: 'Salle (optionnel)',
    batchRoomPlaceholder: 'Salle A1',
    conflictDetectedTitle: "⚠️ Conflits d'horaires détectés!",
    conflictDetectedSub:
      'Le formateur sélectionné a déjà des cours aux mêmes créneaux.',
    conflictingCoursesHdr: '📅 Cours en conflit :',
    conflictRoomLbl: '🏫 Salle :',
    suggestTitle: '💡 Solutions suggérées :',
    suggestLine1: '• Choisir un autre formateur disponible',
    suggestLine2: '• Modifier les jours de la semaine',
    suggestLine3: '• Changer les heures de début/fin',
    suggestLine4: '• Reporter ce groupe à une autre période',

    unknownTrainer: 'Inconnu',
    batchesTabHeading: 'Groupes',

    batchEmptyTitle: 'Aucun groupe créé',
    batchEmptySubtitle:
      'Créez des groupes avec des horaires spécifiques pour ce cours',
    batchCreateFirst: 'Créer le premier groupe',
    lblTrainerColon: 'Formateur :',
    lblRoomColon: 'Salle :',
    lblStartColon: 'Début :',
    lblEndColon: 'Fin :',
    roomUndefined: 'Non définie',
    studentsModalClose: 'Fermer',
    enrollmentProgress: '{current}/{capacity}',

    courseFormLblTitle: 'Titre du cours',
    courseFormLblStartDate: 'Date de début',
    courseFormLblEndDate: 'Date de fin',
    courseFormLblDurationHrs: 'Durée (heures)',
    courseFormLblPriceDa: 'Prix (DA)',
    courseFormLblCapacity: 'Capacité',
    courseFormLblTrainer: 'Formateur',
    courseFormLblStatusShort: 'Statut',
    courseFormOptPending: 'À venir',
    courseFormOptActive: 'En cours',
    courseFormOptCompleted: 'Terminé',
    courseFormLblDescription: 'Description',

    loadingCourse: 'Chargement…',
    courseNotFound: 'Cours introuvable (ID: {id})',
    backCoursesListShort: '← Retour à la liste des cours',
    loadingCourseDetails: 'Chargement des détails du cours…',

    /** Groupes — formulaire cours + salle partagés */
    batchLblCourseShort: 'Cours',
    batchSelectCourse: 'Sélectionner un cours',
    batchSelectRoom: 'Sélectionner une salle',
    batchGroupNamePlaceholder:
      'Ex : Groupe A, matin, soir…',
    batchLblTrainerForm: 'Formateur',
    batchRoomOccupiedSuffix: '- OCCUPÉE',
    roomPickMetaLine:
      '{name} ({code}) · Capacité : {capacity} {occupied}',
    roomDetailsCapacityFloor: 'Capacité : {cap} • Étage : {floor}',
    floorNA: 'N/D',
    equipmentPcShort: '💻 PC',
    tabDetailsCourse: 'Détails',
    sectionDescription: 'Description',
    sectionTrainer: 'Formateur',
    sectionEnrolledStudents: 'Étudiants inscrits',
    lblPeriodShort: 'Période',
    lblDurationShort: 'Durée',
    lblCapacityShort: 'Capacité',
    lblPriceShort: 'Prix',
    newBatchBtn: 'Nouveau groupe',
    courseTitleFallbackShort: 'Cours',
    cancelBtnShort: 'Annuler',
  },

  groupsPage: {
    courseFallbackName: 'Cours',
    batchSaveSuccessUpdated: '✅ Groupe modifié avec succès !',
    batchSaveSuccessCreated: '✅ Nouveau groupe créé avec succès !',
    batchSaveError: "Erreur lors de l'enregistrement du groupe",
    daysNotDefined: 'Non définis',
    nameNotDefined: 'Nom non défini',
    courseNotDefinedShort: 'Cours non défini',
    trainerNotAssigned: 'Non assigné',
    courseNotFoundShort: 'Cours non trouvé',
    statCumulativeCapacityTitle: 'Places cumulées',
    statCumulativeCapacityHint: 'Capacité max des groupes',
    newGroup: 'Nouveau groupe',
    backToList: 'Retour à la liste',
    loadingList: 'Chargement des groupes…',

    statsTotalGroupsTitle: 'Groupes',

    emptyTitleNoMatch: 'Aucun groupe trouvé',
    emptyBodyFiltered: 'Aucun groupe pour ce cours',
    emptyBodyCreateFirst:
      'Créez votre premier groupe de cours',
    createFirstGroup: 'Créer le premier groupe',
    viewStudentsSr: 'Voir les étudiants',
    enrollmentShort: 'Inscriptions',
    noStudentsInBatchTitle: 'Aucun étudiant inscrit',
    noStudentsInBatchBody:
      "Ce groupe n'a pas encore d'étudiants inscrits.",
    studentsModalClose: 'Fermer',

    filterCourseChipLbl: 'Cours',
    filterListHintLbl: 'Filtrer la liste',
    statsAllFormationsHint: 'Toutes formations',
    statsCoursesWithGroupsTitle: 'Cours couverts',
    statsCoursesWithGroupsHint: 'Avec au moins un groupe',
    unknownCourseTitle: 'Cours inconnu',
    groupsPerCourseSuffix: '{n} groupe(s)',
    modalStudentsForBatchTitle: 'Étudiants inscrits — {name}',
    modalTotalStudentCount: 'Total : {n} étudiant(s)',
    modalCapacityLabelShort: 'Capacité',
    enrolledOnPrefix: 'Inscrit le :',
    confirmDeleteGroup:
      'Êtes-vous sûr de vouloir supprimer ce groupe ?',
    deleteGroupError:
      'Erreur lors de la suppression du groupe.',
  },

  certificationsDetail: {
    title: 'Détails du certificat',
    notFoundTitle: 'Certificat introuvable',
    notFoundBody:
      'Impossible de charger les détails de ce certificat.',
    printBtn: 'Imprimer',
    brandLine: 'FORMA PRO EXCELLENCE',
    awardedTo: 'Délivré à :',
    instructorLbl: 'Formateur :',
    issueDateLbl: 'Date de délivrance',
    expiryDateLbl: "Date d'expiration",
    remarksLbl: 'Remarques',
    certificateBodyLegal:
      "Ce document atteste que l'étudiant a achevé le programme avec succès.",
    statusColon: 'Statut :',
    typeColon: 'Type :',
    editBtn: 'Modifier',
    subheadingPortfolio:
      'Vue synthétique du portefeuille',
    emptyListTitle: 'Aucun certificat trouvé',
    emptyListCta: 'Créer un certificat',
    listCardTitle: 'Liste des certificats',
    newFormStub: 'Formulaire de création',
    editPageTitle: 'Modification du certificat',
    typeDiploma: 'Diplôme',
    typeCertificationShort: 'Certification',
    typeAttestation: 'Attestation',
    statusIssuedUpper: 'DÉLIVRÉ',
    statusPendingUpper: 'EN ATTENTE',
    diplomaUpper: 'DIPLÔME',
    certificationUpper: 'CERTIFICATION',
    attestationUpper: 'ATTESTATION',
    statusIssued: 'Délivré',
    statusPendingLabel: 'En attente',
    filterAllTypes: 'Tous les types',
    toastViewStarted: 'Ouverture du certificat {id}',
    toastDownloadStarted: 'Téléchargement du certificat démarré',
    toastDownloadError: 'Erreur : {error}',
    dateShortLbl: 'Date :',
    idShortLbl: 'ID :',
    sectionByTypeTitle: 'Répartition par type',
    pctOfTotalCerts: '{pct}% des certificats',
    searchCertSr: 'Rechercher un certificat',
    searchCertPlaceholder: 'Étudiant, titre ou formateur…',
    emptyFilteredBody:
      'Aucun résultat ne correspond à vos critères de recherche.',
    tableColId: 'ID',
    tableColStudent: 'Étudiant',
    tableColTitle: 'Titre',
    tableColDate: 'Date',
    tableColType: 'Type',
    tableColStatus: 'Statut',
    tableColActions: 'Actions',
    pageSliceShow: 'Affichage {from}–{to} sur {total}',
    toastEditMode: 'Modification du certificat {id}',
    filterTypeChip: 'Type : {label}',
  },

  certificationsComponents: {
    formTitleNew: 'Nouvelle certification',
    formTitleEdit: 'Modifier la certification',
    studentNameLbl: "Nom de l'étudiant",
    selectStudent: 'Sélectionner un étudiant',
    certificateTypeLbl: 'Type de certification',
    certificateTitleLbl: 'Titre',
    issueDateFieldLbl: 'Date de délivrance',
    expirationFieldLbl: "Date d'expiration",
    noExpiryCheckbox: "Valide à vie (pas d'expiration)",
    noExpiryBadge: '✓ Cette certification sera valide à vie',
    scoreFieldLbl: 'Score (sur 100)',
    detailScoreLbl: 'Score',
    instructorNameLbl: 'Nom du formateur',
    selectTrainer: 'Sélectionner un formateur',
    cancelBtn: 'Annuler',
    submitAdd: 'Ajouter',
    submitUpdate: 'Mettre à jour',

    modalPreviewDeliveredPrefix: 'Délivré le :',
    modalPreviewTrainerPrefix: 'Formateur :',
    modalPreviewExpirePrefix: 'Expire le :',
    modalPreviewValidForeverShort: '∞ Valide à vie',
    modalPreviewScorePrefix: 'Score :',

    modalTemplateAlt: 'Modèle',

    svgPdfLoadedFallback: 'Modèle PDF chargé',
    svgPdfSubFallback: '(Aperçu simplifié — le PDF final utilisera votre modèle)',

    modalTemplateLoading: 'Chargement de votre template…',
    modalTemplateRequired: 'Template requis',
    modalTemplateRequiredBody:
      'Aucun template de certificat n’est configuré. Veuillez en téléverser un dans les paramètres.',
    modalGoSettings: 'Aller aux paramètres',
    modalPreviewWithTemplate:
      '✨ Aperçu avec votre template personnalisé : {name}. Le PDF exporté utilisera le même positionnement.',
    modalPreviewNoTemplate:
      'Aucun template personnalisé n’est configuré. Paramètres → Certificats pour en ajouter un.',

    modalDownloadPdf: 'Télécharger PDF',
    modalPreparing: 'Préparation du certificat…',
    modalDownloadOkTitle: 'Téléchargement réussi !',
    modalDownloadOkBody: 'Le certificat a été téléchargé avec succès.',
    modalPrintNow: 'Imprimer maintenant',
    modalErrorRetry: 'Une erreur est survenue. Veuillez réessayer.',
    modalRetryBtn: 'Réessayer',
    modalMetaSectionTitle: 'Détails du certificat',
    modalCertIdMeta: 'ID certificat',
    modalStudentIdMeta: 'ID étudiant',
    modalPrintErrorAlert:
      'Erreur lors de l’impression. Veuillez réessayer.',

    listEmptyTitle: 'Aucune certification trouvée',
    listEmptyBody:
      'Aucune certification ne correspond aux critères de recherche sélectionnés.',

    dateNotDefined: 'Non définie',
    printExpiresLine: 'Expire le :',

    detailDeliveredPrefixIssued: 'Délivré le',
    detailDeliveredPrefixPending: 'prévu pour le',
    detailDatePending: 'date à définir',
    detailStudentLbl: 'Étudiant',
    detailTrainerLbl: 'Formateur',
    detailExpirySectionLbl: "Date d'expiration",
    detailNoExpirySub: '(Aucune expiration)',
    detailExpired: 'Expiré',
    detailClose: 'Fermer',
    detailDownloading: 'Téléchargement…',
    detailDownloadBtn: 'Télécharger',
    detailPdfFailAlert:
      'Erreur lors de la génération du PDF. Veuillez réessayer.',
    detailGenericFailAlert:
      'Une erreur s’est produite. Veuillez réessayer.',

    downloadAlertOk: 'Certificat téléchargé avec succès',

    printDocTitleBase: 'Certificat',

    printOverlayIssued: 'Délivré le :',
    printOverlayTrainer: 'Formateur :',
    printOverlayExpires: 'Expire le :',
    printOverlayInfinity: '∞ Valide à vie',
    printOverlayScore: 'Score :',
    printOverlayFooterLine: 'ID : {id} · Généré par FORMAPRO',

    printDefaultIntro: 'Ce document certifie que',
    printDefaultSuccessLine: 'a complété avec succès',
    printDefaultIssuedLbl: 'Date de délivrance :',
    printDefaultTrainerLbl: 'Formateur :',
    printDefaultExpiryLbl: "Date d'expiration :",
    printDefaultScoreLbl: 'Score :',
    printDefaultValidityForever: '∞ Valide à vie',
    printDefaultSigTrainer: 'Signature du formateur',
    printDefaultSigDir: 'Direction',
    printDefaultSealValidated: 'VALIDÉ',
    printDefaultFooterMeta: 'ID : {id} · Généré par FORMAPRO',
    printDefaultHdrSuffix: ' — FORMAPRO',
  },

  schedulePageUi: {
    edit: 'Modifier',
    delete: 'Supprimer',
    schedulesLbl: 'Horaires',
    trainerLbl: 'Formateur',
    classroomLbl: 'Salle',
    courseLbl: 'Cours',
    loadingTitle: '🔄 Chargement de l’emploi du temps…',
    loadingSub:
      'Synchronisation avec les sessions, cours, groupes, salles et formateurs',
    newCourseShortcut: 'Nouveau cours',
    repartitionDayTitle: 'Répartition par jour',
    weeklyLoadSubtitle: 'Charge hebdomadaire',
    filterAllCourses: 'Tous les cours',
    filterConfirmed: 'Confirmés',
    filterPendingSessions: 'En attente',
    dayViewTitle: 'Vue du jour',
    dailySummaryTitle: 'Résumé du jour',
    totalCoursesLbl: 'Cours au total',
    courseUnspecified: 'Cours non spécifié',
    trainerUnspecified: 'Formateur non spécifié',
    classroomUnspecified: 'Salle non spécifiée',
    statEventsScheduled: 'Événements planifiés',
    statSlotsWeek: 'Créneaux sur la semaine',
    statTrainersReferential: 'Référentiel formateurs',
    sessionDeletedToast: 'Session supprimée avec succès',
    confirmDeleteSession:
      'Êtes-vous sûr de vouloir supprimer cette session de formation ?',
    deleteDeniedBatch:
      'Supprimez ce groupe depuis la page Cours ou Groupes',
    deleteErrorToast:
      'Une erreur est survenue lors de la suppression',
    statRoomsAvailableHint: 'Espaces disponibles',
    kpiTotalCoursesTitle: 'Total cours',
    kpiThisWeekTitle: 'Cette semaine',
    kpiFormateursTitle: 'Formateurs',
    kpiRoomsTitleShort: 'Salles',
    tabWeekView: 'Vue semaine',
    tabDayView: 'Vue jour',
    tabByTrainer: 'Par formateur',
    tabByCourse: 'Par cours',
    tabByRoom: 'Par salle',
    pctOfCoursesLine: '{pct}% des cours',
    searchCoursesSr: 'Rechercher un cours',
    searchPlaceholderSchedule: 'Titre, formateur, salle…',
    clearSearchShort: 'Effacer',
    monthCoursesSummary: '{n} cours ce mois',
    calendarMoreOther: '+{n} autre',
    calendarMoreOthers: '+{n} autres',
    eventHoverTimeRange: '{title} · {start} à {end}',
    eventDetailTitle: 'Détails du cours',
    linkTrainersPage: 'Voir page formateurs',
    linkRoomsPage: 'Voir page salles',
    linkCoursesPage: 'Voir page cours',
    capacityLine: 'Capacité : {n} places',
    codeLblShort: 'Code :',
    coursesByTrainerTitle: 'Emploi du temps par Formateur',
    coursesByCourseTitle: 'Emploi du temps par Cours',
    coursesByRoomTitle: 'Emploi du temps par Salle',
    coursesThisWeekLine: '{n} cours cette semaine',
    sessionsThisWeekLine: '{n} sessions cette semaine',
    trainerFallbackName: 'Formateur',
    statusActiveLbl: 'Actif',
    statusInactiveLbl: 'Inactif',
    noCoursesAssignedWeek: 'Aucun cours assigné cette semaine',
    noSessionsPlannedWeek: 'Aucune session planifiée cette semaine',
    roomSessionsMeta: 'Capacité : {cap} • {n} sessions',
    occupancyPct: "{pct}% d'occupation",
    roomFreeThisWeek: 'Salle libre cette semaine',
    fallbackDay: 'Jour',
    durationHoursShort: '{n}h',
    durationUnknown: 'N/A',
    groupLabelShort: 'Groupe {name}',
    stubAddCourse: 'Ajouter un nouveau cours',
    stubEditCourse: 'Modifier le cours',
    modalAddCourseTitle: 'Ajouter un cours',
    modalSelectCourse: 'Sélectionner un cours',
    modalSelectTrainer: 'Sélectionner un formateur',
    modalSelectRoom: 'Sélectionner une salle',
    batchStartLbl: 'Heure de début',
    batchEndLbl: 'Heure de fin',
    closeModalBtn: 'Fermer',
    cancelModalBtn: 'Annuler',
    addModalSubmit: 'Ajouter',
    summaryTrainersLbl: 'Formateurs',
    summaryRoomsUsedLbl: 'Salles utilisées',
    summaryHoursTotalLbl: 'Heures total',
    sessionDefaultTitle: 'Formation',
    todayLabel: "Aujourd'hui",
  },

  paymentsPageUi: {
    methodCash: 'Espèces',
    methodCard: 'Carte',
    transfer: 'Virement',
    methodCheck: 'Chèque',
    unspecified: 'Non spécifié',
    undef: 'Non défini',
    noCourseChosen: 'Aucun cours spécifié',
    paidLbl: 'Payé',
    partialLbl: 'Partiellement payé',
    toastSelectStudent:
      'Veuillez sélectionner un étudiant',
    toastSelectEnrollment:
      'Veuillez sélectionner une inscription (groupe)',
    amountPaidGtTotal:
      'Le montant payé ne peut pas dépasser le montant total',
    amountPaidMustBeGt0:
      'Le montant payé doit être supérieur à 0',
    saveErrorToast:
      "Une erreur est survenue lors de l'enregistrement des données",
    helperNoStudentOrCourse:
      'Aucun étudiant ni cours trouvé. Ajoutez-les dans leurs pages respectives.',
    helperNoStudent:
      'Aucun étudiant trouvé. Ajoutez des étudiants dans la page Étudiants.',
    helperNoCourses:
      'Aucun cours trouvé. Ajoutez des cours dans la page Cours.',
    selectStudentPlaceholder: 'Sélectionner un étudiant',
    noStudentsAvail: 'Aucun étudiant disponible',
    courseAssignedShort: 'Cours assigné',
    pickStudentFirstHint:
      'Sélectionnez d\'abord un étudiant',
    selectBatchPlaceholder: 'Sélectionner un groupe',
    badgePaidSuffix: 'Payé',
    badgePartialSuffix: 'Partiel',
    badgePendingSuffix: 'En attente',
    placeholderAmountPaid: 'Saisissez le montant payé',
    placeholderCoursePrice:
      'Sélectionnez un cours pour voir le prix',
    placeholderNotesPayment:
      'Informations complémentaires sur ce paiement…',
    btnUpdate: 'Mettre à jour',
    btnSave: 'Enregistrer',
    statTotalPaymentsTitle: 'Total paiements',
    statTotalPaymentsHint: 'Enregistrements',
    statAmountPaidTitle: 'Montant payé',
    statAmountPaidHint: 'Encaissements cumulés',
    statFullyPaidTitle: 'Complètement payés',
    statFullyPaidHint: 'Factures soldées',
    statOutstandingTitle: 'Reste à encaisser',
    emptyPaymentsHint: 'Aucun paiement à afficher',
    phoneFallback: 'Téléphone non renseigné',
    pdfExportOk: 'PDF exporté avec succès',
    searchPlaceholderPayments:
      'Référence, étudiant, cours…',
    tabPaidOnly: 'Payés uniquement',
    tabPartialOnly: 'Partiels uniquement',
    paymentDetailMissing: 'Détails du paiement introuvables.',
    invoicePrefix: 'Facture #',
    issuedOnLbl: 'Émise le',
    clientLbl: 'Client',
    courseSectionLbl: 'Cours',
    paymentDetailsLbl: 'Détails du paiement',
    courseTotalLbl: 'Montant total du cours',
    paidAmountLbl: 'Montant payé',
    remainingLbl: 'Reste à payer',
    closeBtn: 'Fermer',
    studentFallbackName: 'Étudiant',
    methodCardBank: 'Carte bancaire',
    methodTransferBank: 'Virement bancaire',
    backToPayments: 'Retour aux paiements',
    newPaymentBtn: 'Nouveau paiement',
    searchPaymentsSr: 'Rechercher un paiement',
    clearSearchAria: 'Effacer la recherche',
    tabAll: 'Tous',
    tabPaidShort: 'Payés',
    tabPartialShort: 'Partiels',
    tabOverdueShort: 'En retard',
    tabOverdueOnly: 'En retard uniquement',
    lblDueDateField: 'Date d\'échéance',
    dueDateLbl: 'Échéance du solde',
    dueDateHint: 'Prérempli selon les conditions de paiement ({days} jours) — Paramètres → Facturation',
    overdueBadge: 'En retard',
    toastDueDateRequired: 'Veuillez indiquer une date d\'échéance pour le solde restant',
    colDueDateTbl: 'Échéance',
    activeFiltersLbl: 'Filtres actifs',
    resetFiltersBtn: 'Réinitialiser',
    bulkSelectedPayments: '{n} paiement(s) sélectionné(s)',
    deselectAllBtn: 'Tout désélectionner',
    deleteBulkBtn: 'Supprimer ({n})',
    paymentListHeading: 'Liste des paiements',
    pageSliceShown: 'Affichage {start}–{end} sur {total}',
    colReferenceShort: 'Référence',
    colStudentShort: 'Étudiant',
    colCourseTbl: 'Cours',
    colDateTbl: 'Date',
    colAmountTbl: 'Montant',
    colStatusTbl: 'Statut',
    colActionsTbl: 'Actions',
    statOutstandingOpenHint: 'Montants ouverts',
    installmentsHeading: 'Échéancier de paiement',
    installmentNth: 'Échéance {n}',
    installmentDatePrefix: 'Date :',
    paymentMethodLbl: 'Méthode de paiement',
    lblStatusPayment: 'Statut',
    formTitleNewPayment: 'Nouveau paiement',
    formTitleEditPayment: 'Modifier le paiement',
    lblStudentField: 'Étudiant',
    lblEnrollmentField: 'Inscription (Groupe)',
    lblTotalAmountField: 'Montant total (DA)',
    lblDateField: 'Date',
    lblPaymentKind: 'Type de paiement',
    paymentKindFull: 'Paiement complet',
    paymentKindPartial: 'Paiement partiel',
    lblPaidTodayField: "Montant payé aujourd'hui (DA)",
    lblRemarksField: 'Remarques',
    placeholderNotesSupplement:
      'Informations supplémentaires sur ce paiement…',
    labelMontantTotalShort: 'Montant total :',
    labelMontantPayeShort: 'Montant payé :',
    labelMontantRestantShort: 'Montant restant :',
    selectStudentFirstBanner:
      'Veuillez d’abord sélectionner un étudiant pour voir ses inscriptions',
    enrollmentCountBanner: '{n} inscription(s) active(s)',
    studentCountAvail: '{n} étudiant(s) disponible(s)',
    cancelLink: 'Annuler',
    toastTotalAmountRequired: 'Le montant total est requis',
    toastStudentEnrollFound:
      '{n} inscription(s) trouvée(s) pour {name}',
    toastNoActiveEnrollmentStudent:
      'Aucune inscription active pour {name}',
    toastBatchSelectedPrice:
      'Groupe « {batch} » sélectionné — Prix : {price} DA',
    studentMissingPlaceholder: 'Étudiant introuvable',
    courseNotFoundTitle: 'Cours introuvable',
    confirmDeleteOnePayment:
      'Êtes-vous sûr de vouloir supprimer ce paiement ?',
    toastPaymentDeletedOk: 'Paiement supprimé avec succès',
    toastPaymentDeleteFail:
      'Une erreur est survenue lors de la suppression',
    toastBulkPaymentsDeletedOk:
      '{n} paiement(s) supprimé(s) avec succès',
    toastBulkPaymentsDeleteFail:
      'Erreur lors de la suppression des paiements',
    bulkDeleteTitlePayments: 'Confirmer la suppression',
    bulkDeleteAskPayments:
      'Êtes-vous sûr de vouloir supprimer {n} paiement(s) ? Cette action est irréversible.',
    cancelBtnPayments: 'Annuler',
    deleteBtnPayments: 'Supprimer',
    titleViewPayment: 'Voir',
    titleEditPayment: 'Modifier',
    titleExportPdf: 'Exporter PDF',
    titlePrintReceipt: 'Imprimer',
    titleDeletePayment: 'Supprimer',
    toastWaitSettingsLoad:
      'Chargement en cours, veuillez patienter…',
    toastMemberInfoMissingPayment:
      'Impossible de trouver les informations du membre pour ce paiement',
    toastPdfExportError: "Erreur lors de l'export PDF",
    toastPrintIframeError:
      'Erreur lors du chargement de l\'impression',
    toastPrintError: "Erreur lors de l'impression",
    orgFallbackAddress: 'École de Formation',
    pdfReceiptTitle: 'REÇU',
    pdfLblNum: 'N° :',
    pdfLblDate: 'Date :',
    pdfLblReceivedFrom: 'Reçu de :',
    pdfLblFor: 'Pour :',
    pdfLblMethod: 'Méthode :',
    pdfLblReference: 'Référence :',
    pdfLblAmount: 'Montant :',
    pdfLblAmountWords: 'En lettres :',
    pdfDinarsTail: '{words} dinars',
    pdfDescFormation: 'Paiement de formation',
    pdfNumericAmountFallback: '{amount}',
    printCloseBtn: '✕ Fermer',
    paginationAriaLabel: 'Pagination',
    paginationPrev: 'Précédent',
    paginationNext: 'Suivant',
  },

  sessionsPageTabs: {
    attendance: 'Présences',
    completed: 'Terminées',
    cancelled: 'Annulées',
  },

  sessionsPageUi: {
    backToList: 'Retour à la liste',
    newSessionBtn: 'Nouvelle session',
    courseFallbackShort: 'Cours',
    trainerFallbackShort: 'Formateur',
    roomTbdShort: 'Salle TBD',
    statSessionsTodayTitle: "Sessions aujourd'hui",
    statSessionsTodayHint: 'Check-in enregistrés aujourd’hui',
    statActiveSessionsTitle: 'Sessions actives',
    statActiveSessionsHint: 'Membres actuellement en salle (sans check-out)',
    statAvgDurationTitle: 'Durée moyenne',
    statAvgDurationHintAvg: 'Moyenne sur les sessions terminées',
    statAvgDurationHintNone: 'Aucune durée enregistrée',
    minSuffix: '{n} min',
    dashEm: '—',
    tabAllSessions: 'Toutes les Sessions',
    tabScheduleBtn: 'Planning',
    tabActiveSessions: 'Sessions Actives',
    tabCheckIn: 'Enregistrer',
    tabTrainingFormation: 'Formation',
    tabStats: 'Statistiques',
    distByStatusHeading: 'Répartition par statut',
    distByStatusSub: 'Vue d’ensemble de vos sessions enregistrées',
    distNameCompleted: 'Terminées',
    distNameActive: 'Actives',
    distNameCancelled: 'Annulées',
    distPctSessions: '{pct}% des sessions',
    searchSrOnly: 'Rechercher une session',
    searchPlaceholderMemberId: 'Membre ou ID de session…',
    clearSearchAriaSessions: 'Effacer la recherche',
    filtAllStatuses: 'Tous les statuts',
    filtStatusActivePlural: 'Actives',
    filtChipStatus: 'Statut : {status}',
    filtersActiveLbl: 'Filtres actifs',
    resetFiltersSessions: 'Réinitialiser',
    trainingSessionsHeading: 'Sessions de Formation',
    newTrainingBtn: 'Nouvelle Formation',
    emptyTrainingTitle: 'Aucune session de formation',
    emptyTrainingBody:
      "Vous n'avez pas encore créé de sessions de formation. Commencez par en ajouter une nouvelle.",
    scheduleCoursesHeading: 'Planning des Cours',
    weeklyViewLbl: 'Vue hebdomadaire',
    scheduleConflictsTitle: "⚠️ Conflits d'horaires détectés",
    scheduleConflictsSub:
      '{nGroups} groupe(s) en conflit • {nTrainers} formateur(s) concerné(s)',
    actionRequiredLbl: 'Action requise',
    resolveConflictsCourses: 'Résoudre les conflits dans Cours',
    noCoursesScheduledTitle: 'Aucun cours planifié',
    noCoursesScheduledBody:
      'Créez des groupes dans la section Cours pour voir le planning',
    dayCellNoCourse: 'Aucun cours',
    conflictTrainerBadge: '⚠️ Conflit formateur',
    slotFullLbl: 'Complet',
    slotOpenLbl: 'Ouvert',
    conflictsDetectedLine: 'Conflits détectés:',
    andMoreOthers: '… et {n} autre(s)',
    todaysClassesHeading: "Classes d'aujourd'hui",
    noCoursesToday: "Aucun cours prévu aujourd'hui",
    attendanceHeading: 'Suivi des Présences',
    dailyMgmtLbl: 'Gestion quotidienne',
    selectBatchLbl: 'Sélectionner un groupe',
    pickBatchPlaceholder: 'Choisir un groupe',
    batchOptionCourseStudents: '{course} — {batch} ({n} étudiants)',
    sessionDateLbl: 'Date de la session',
    selectedSessionLine: 'Session sélectionnée : {date}',
    toggleHideStatsLbl: 'Masquer les statistiques',
    toggleShowStatsLbl: 'Voir les statistiques',
    emptyBatchStudentsTitle: 'Aucun étudiant inscrit',
    emptyBatchStudentsBody:
      "Ce groupe n'a pas encore d'étudiants inscrits.",
    rosterHeading: 'Liste de présence — {batch}',
    markAllPresent: 'Tous présents',
    markAllAbsent: 'Tous absents',
    presentLbl: 'Présent',
    absentLbl: 'Absent',
    notesOptionalPh: 'Notes (optionnel)',
    saveAttendanceBtn: 'Sauvegarder les présences',
    attendanceSavedToast: '✅ Présences sauvegardées !\n✅ Présents : {present}\n❌ Absents : {absent}',
    attendanceSaveError: '❌ Erreur lors de la sauvegarde des présences',
    statsAttendanceHeading: 'Statistiques de présence',
    noAttendanceYetGroup: 'Aucun enregistrement de présence pour ce groupe',
    statsSessionsRecordedLbl: 'Sessions enregistrées',
    statsAvgAttendanceRateLbl: 'Taux moyen de présence',
    statsStudentsTrackedLbl: 'Étudiants suivis',
    rateByStudentHeading: 'Taux de présence par étudiant',
    scheduleConflictChip: '⚠️ Conflit',
    conflictTrainerOtherCourses:
      'Conflit avec {n} autre(s) cours du formateur',
    studentsCountShort: '{n} étudiants',
    spotsLeftSuffix: '{n} places',
    emptySessionListTitle: 'Aucune session trouvée',
    emptySessionListBody:
      'Aucun résultat ne correspond à vos critères de recherche.',
    createSessionBtn: 'Créer une session',
    bulkSelectedSessions: '{n} session(s) sélectionnée(s)',
    deselectAllSessions: 'Désélectionner tout',
    deleteBulkSessions: 'Supprimer ({n})',
    listSectionHeadingSessions: 'Sessions',
    pageSliceSessions:
      'Affichage {start}–{end} sur {total}',
    zeroSessionsLbl: '0 session',
    colSessionId: 'ID Session',
    colMember: 'Membre',
    colCheckIn: "Heure d'entrée",
    colCheckOut: 'Heure de sortie',
    colDuration: 'Durée',
    colStatusSessions: 'Statut',
    colActionsSessions: 'Actions',
    sessionInProgress: 'En cours',
    optStatusActive: 'Active',
    optStatusCompleted: 'Terminée',
    optStatusCancelled: 'Annulée',
    titleClickEditStatus: 'Cliquer pour modifier le statut',
    badgeStatusCompleted: 'Terminée',
    badgeStatusActive: 'Active',
    badgeStatusCancelled: 'Annulée',
    titleViewDetails: 'Voir les détails',
    titleEditSessions: 'Modifier',
    titleDeleteSessions: 'Supprimer',
    paginationAriaSessions: 'Pagination',
    paginationPrevSessions: 'Précédent',
    paginationNextSessions: 'Suivant',
    bulkSessionsDeletedOk:
      '{n} session(s) supprimée(s) avec succès',
    bulkSessionsDeleteFail: 'Erreur lors de la suppression des sessions',
    confirmDeleteOneSessionRegular:
      'Êtes-vous sûr de vouloir supprimer cette session ?',
    statusUpdateFail: 'Erreur lors de la mise à jour du statut',
    bulkConfirmTitleSessions: 'Confirmer la suppression',
    bulkConfirmAskSessions:
      'Êtes-vous sûr de vouloir supprimer {n} session(s) ? Cette action est irréversible.',
    bulkCancelSessions: 'Annuler',
    bulkDeleteSessionsBtn: 'Supprimer',
    invalidTimeLabel: '-',
    timeInvalid: 'Invalid Date',
    trainingCardDateLbl: 'Date',
    trainingCardScheduleLbl: 'Horaire',
    trainingCardPlaceLbl: 'Lieu',
    trainingCardTrainerLbl: 'Formateur',
    trainingCardDurationLbl: 'Durée',
    trainingCardSeatsLbl: 'Places',
    trainingCardPriceLbl: 'Prix',
    trainingRelativeDone: 'Terminé',
    trainingRelativeToday: "Aujourd'hui",
    trainingRelativeTomorrow: 'Demain',
    trainingRelativeInDays: 'Dans {n} jours',
    trainingDurationHM: '{h}h {m}min',
    trainingDurationH: '{h}h',
    checkInSelectMemberToast: 'Veuillez sélectionner un membre',
    checkInNoActiveSessionErr: 'Aucune session active trouvée pour ce membre',
    checkInOutOk: 'Sortie enregistrée avec succès',
    checkInOk: 'Entrée enregistrée avec succès',
    checkInSaveErr: "Erreur lors de l'enregistrement",
    checkInCameraErr: "Impossible d'accéder à la caméra",
    subNoneLbl: 'Aucun abonnement',
    subExpiredLbl: 'Abonnement expiré',
    subExpiresInDays: 'Expire dans {n} jours',
    subActiveLbl: 'Abonnement actif',
    subNoneFallback: 'Aucun',
    checkInWarnNoSubTitle: 'Attention : Aucun abonnement actif',
    checkInWarnNoSubBody:
      "Ce membre n'a pas d'abonnement actif. Voulez-vous quand même procéder ?",
    checkInWarnExpiredTitle: 'Attention : Abonnement expiré',
    checkInWarnExpiredBody:
      "L'abonnement de ce membre a expiré le {date}. Voulez-vous quand même procéder ?",
    checkInNotesPlaceholder: 'Ajouter des notes sur cette séance…',
    checkInRegisterIn: "Enregistrer l'entrée",
    checkInRegisterOut: 'Enregistrer la sortie',
    checkInSearchPlaceholder: 'Rechercher un membre (nom ou code)...',
    checkInQrBtn: 'Scanner QR',
    checkInRecentActivity: 'Activité Récente',
    unknownMember: 'Membre inconnu',
    checkInPlaceholderSearchLong:
      'Rechercher un membre (nom, code, email, téléphone...)',
    checkInStopScanner: 'Arrêter',
    checkInScannerStart: 'Scanner',
    checkInNoMembersFound:
      'Aucun membre trouvé. Veuillez essayer avec un autre terme de recherche.',
    phoneLblShort: 'Téléphone',
    subLblShort: 'Abonnement',
    expiryLblShort: 'Expiration',
    notesFieldLbl: 'Notes (facultatif)',
    checkInToggleLbl: 'Check-in',
    checkOutToggleLbl: 'Check-out',
    checkInDurationHM: '{h}h {m}m',
    checkInDurationM: '{m}m',
    inRoomSince: 'En salle depuis {dur}',
    sessionsInProgressHeading: 'Séances en cours ({n})',
    trainingDetailTitle: 'Détails de la session',
    trainingTabDetails: 'Détails',
    trainingTabResources: 'Ressources',
    trainingTabStudents: 'Étudiants',
    trainingStartDateLbl: 'Date de début',
    trainingEndDateLbl: 'Date de fin',
    trainingStartDateOptionalLbl: 'Date de début (optionnel)',
    trainingEndDateOptionalLbl: 'Date de fin (optionnel)',
    trainingTotalDurationLbl: 'Durée totale',
    trainingLocationLbl: 'Lieu',
    trainingCapacityLbl: 'Capacité',
    trainingTrainerLbl: 'Formateur',
    trainingPriceLbl: 'Prix',
    trainingDescriptionLbl: 'Description',
    trainingPrerequisitesLbl: 'Prérequis',
    trainingEquipmentLbl: 'Équipement requis',
    trainingNoResourcesTitle: 'Aucune ressource disponible',
    trainingNoResourcesBody: 'Aucune ressource pédagogique n\'a été ajoutée à cette session.',
    trainingNoStudentsTitle: 'Aucun étudiant inscrit',
    trainingNoStudentsBody: 'Aucun étudiant n\'est inscrit à cette session de formation.',
    trainingPlacesReservedLbl: 'places réservées',
    trainingPlacesReservedHeading: 'Places réservées',
    trainingStatusUpcoming: 'À venir',
    trainingStatusInProgress: 'En cours',
    trainingStatusFinished: 'Terminée',
    trainingStatusUndefined: 'Non défini',
    trainingStudentColName: 'Nom',
    trainingStudentColStatus: 'Statut',
    trainingStudentColEnrolled: 'Date d\'inscription',
    trainingStudentConfirmed: 'Confirmé',
  },

  classroomsPage: {
    notFound: 'Salle non trouvée',
    nameUndefined: 'Nom non défini',
    codeUndefined: 'Code non défini',
    codeColon: 'Code:',
    lblType: 'Type',
    capacitySuffix: '{n} étudiants',
    lblFloorShort: 'Étage',
    notSpecifiedFloor: 'Non spécifié',
    equipment: 'Équipements',
    noEquipment: 'Aucun équipement',
    descriptionHeading: 'Description',
    featuresHeading: 'Caractéristiques',
    projector: 'Projecteur',
    airConditioning: 'Climatisation',
    computers: 'Ordinateurs',
    whiteboard: 'Tableau blanc',
    available: 'Disponible',
    occupied: 'Occupée',
    formTitleEdit: 'Modifier la salle',
    formTitleAdd: 'Ajouter une salle',
    lblName: 'Nom de la salle',
    placeholderName: 'Salle A1, Laboratoire Informatique, etc.',
    lblCode: 'Code',
    placeholderCode: 'S01, LAB-INFO, etc.',
    lblTypeShort: 'Type',
    selectType: 'Sélectionner un type',
    typeCourseRoom: 'Salle de cours',
    typeComputerLab: 'Laboratoire informatique',
    typeConferenceRoom: 'Salle de conférence',
    typeWorkshop: 'Atelier pratique',
    lblCapacityShort: 'Capacité',
    capacityPlaceholderStudents: "Nombre d'étudiants",
    lblFloor: 'Étage',
    floorPlaceholder: 'RDC, 1er étage, etc.',
    lblStatusShort: 'Statut',
    statusAvailableSelect: 'Disponible',
    statusOccupiedSelect: 'Occupée',
    lblEquipmentCsv: 'Équipements',
    equipmentCsvPlaceholder: 'Projecteur, PC, Tableau, etc. (séparés par des virgules)',
    lblDescriptionShort: 'Description',
    descriptionPlaceholder: 'Description ou notes concernant cette salle…',
    featuresFormHeading: 'Caractéristiques',
    cancelBtn: 'Annuler',
    submitAdd: 'Ajouter',
    submitUpdate: 'Mettre à jour',
    saveError: "Une erreur est survenue lors de l'enregistrement des données",
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette salle ?',
    deleteError: 'Une erreur est survenue lors de la suppression',
    statRoomsTitle: 'Salles',
    statRoomsHint: 'Enregistrées',
    statAvailableTitle: 'Disponibles',
    statAvailableHint: 'Statut libre',
    statCapacityTitle: 'Capacité',
    statCapacityHint: 'Places cumulées',
    availChipAvailable: 'Disponibles',
    availChipOccupied: 'Occupées',
    clearSearchAria: 'Effacer la recherche',
    typeTabsAll: 'Tous les types',
    paginationDisplay: 'Affichage {range} sur {total} · page {page} sur {pages}',
    availTabsAll: 'Tous statuts',
    lblRoomTypeUpper: 'Type de salle',
    lblAvailUpper: 'Disponibilité',
    filtersActiveLbl: 'Filtres actifs',
    resetBtn: 'Réinitialiser',
    searchSr: 'Rechercher une salle',
    searchPlaceholder: 'Nom, code ou type…',
    emptyTitle: 'Aucune salle à afficher',
    emptyBody: 'Modifiez les filtres ou ajoutez une salle.',
    clearFiltersSearch: 'Effacer filtres et recherche',
    addRoom: 'Ajouter une salle',
    newRoomShortcut: 'Nouvelle salle',
    listHeading: 'Liste des salles',
    resultsSingular: 'résultat',
    resultsPlural: 'résultats',
    rangeOn: 'plage',
    onTotal: 'sur',
    perPage: 'par page',
    placesShort: '{n} places',
    unnamed: 'Sans nom',
    tableColRoom: 'Salle',
    tableColType: 'Type',
    tableColCapacity: 'Capacité',
    tableColFloor: 'Étage',
    tableColStatus: 'Statut',
    tableColActions: 'Actions',
    titleViewSr: 'Voir',
    titleEditSr: 'Modifier',
    titleDeleteSr: 'Supprimer',
    paginationAria: 'Pagination',
    paginationPrev: 'Précédent',
    paginationNext: 'Suivant',
    backToList: 'Retour à la liste',
  },

  pageDescriptions: {
    sessions: "Gestion des sessions d'entraînement et de formation",
    classrooms: 'Gestion des salles et espaces de formation',
    reports: "Visualisez et analysez les données de l'école",
    groups: 'Créez et gérez les groupes de cours avec horaires et formateurs',
    payments: 'Gestion des paiements et transactions',
    evaluations: 'Suivi des évaluations par module et par apprenant.',
    benefits: 'Tableau de bord financier — indicateurs synchronisés avec le serveur (D1).',
    certifications: 'Délivrance et suivi des diplômes, certifications et attestations',
    schedule: 'Sessions, cours et salles — vue calendaire mise à jour en temps réel.',
  },

  benefitsTabs: {
    overviewName: 'Aperçu financier',
    overviewDesc: 'Vue générale des finances et revenus de formation',
    teachersName: 'Formateurs',
    teachersDesc: 'Gestion des formateurs et leurs performances pédagogiques',
    revenueName: 'Revenus formations',
    revenueDesc: 'Analyse des revenus par cours et formations',
    expensesName: 'Dépenses éducatives',
    expensesDesc: 'Gestion des coûts de formation et équipements',
    devFallback: 'Contenu en développement',
  },

  certificationsPage: {
    statTotalTitle: 'Total certificats',
    statTotalHint: 'Tous types confondus',
    statIssuedTitle: 'Délivrés',
    statIssuedHint: 'Statut délivré',
    statPendingTitle: 'En attente',
    statPendingHint: 'À compléter ou émettre',
    typeDiploma: 'Diplômes',
    typeCertification: 'Certifications',
    typeAttestation: 'Attestations',
    tabAll: 'Tous les Certificats',
    tabIssued: 'Délivrés',
    tabPending: 'En Attente',
    tabDiploma: 'Diplômes',
    tabCertification: 'Certifications',
    tabAttestation: 'Attestations',
    emptyFiltered: 'Aucun certificat',
    deleteToastError: 'Erreur lors de la suppression de la certification',
    confirmDeleteCert: 'Êtes-vous sûr de vouloir supprimer cette certification ?',
    deleteSuccessToast: 'Certification supprimée avec succès',
    notFoundDeleteToast: 'Erreur: Certification non trouvée',
    newCertificateBtn: 'Nouveau certificat',
    backToList: 'Retour à la liste',
    toastAddSuccess: 'Certificat ajouté avec succès',
    toastUpdateSuccess: 'Certificat modifié avec succès',
  },

  evaluationsUi: {
    newEvaluationBtn: 'Nouvelle évaluation',
    searchPlaceholder: 'Rechercher par étudiant, module, formateur…',
    allModules: 'Tous les modules',
    confirmDeleteEvaluation:
      'Êtes-vous sûr de vouloir supprimer cette évaluation ?',
    emptyTitle: 'Aucune évaluation trouvée',
    emptyBody:
      'Aucune évaluation ne correspond aux critères de recherche sélectionnés.',
    loading: 'Chargement…',
    typeExam: 'Examen',
    typeProject: 'Projet',
    typeQuiz: 'Quiz',
    statusPending: 'En attente',
    statusCompleted: 'Terminée',
    evalDateLabel: "Date d'évaluation",
    scoreOutOfLabel: 'Sur',
    studentLabel: 'Étudiant',
    moduleLabel: 'Module',
    dateLabel: 'Date',
    scoreLabel: 'Score',
    commentsSection: 'Commentaires',
    strengthsLabel: 'Points forts',
    improvementsLabel: 'Points à améliorer',
    recommendationsLabel: 'Recommandations',
    evaluatedByLabel: 'Évalué par',
    noCommentLabel: 'Aucun commentaire',
    detailsBtn: 'Détails',
    selectModule: 'Sélectionner un module',
    selectStudent: 'Sélectionner un étudiant',
    studentNameLabel: 'Étudiant',
    evalTypeLabel: "Type d'évaluation",
  },

  reportsPage: {
    goToPayments: 'Allez à la page Paiements pour ajouter des transactions',
    dataWillAppear: 'Les données apparaîtront automatiquement ici une fois les paiements ajoutés',
    periodCol: 'Période',
    activeStudentsOnly: 'Étudiants actifs seulement',
    reportTypeLabel: 'Type de rapport',
    periodLabel: 'Période',
    startDateLabel: 'Date de début',
    endDateLabel: 'Date de fin',
    financialReportTitle: 'Rapport Financier',
    financialReportDesc: 'Aperçu des revenus, dépenses et bénéfices',
    periodDisplay: 'Période personnalisée',
    financialSummary: 'Résumé Financier',
    newStudents: 'Nouveaux étudiants',
    activeStudentsLabel: 'Étudiants actifs',
    inactiveStudents: 'Étudiants inactifs',
    totalStudents: 'Total étudiants',
    waitForData: 'Veuillez attendre que les données se chargent avant d\'exporter',
    noRevenueData: 'Aucune donnée de revenus',
    revenueCol: 'Revenus',
    expensesCol: 'Dépenses',
    profitCol: 'Bénéfice',
    loadingFinancialData: 'Chargement des données financières...',
    loadingData: 'Chargement des données...',
    noCourseAvailable: 'Aucun cours disponible',
    createCourseHint: 'Créez des cours dans la section Cours pour voir la répartition',
    noFinancialDataAvailable: 'Aucune donnée financière disponible',
    noStudentDataAvailable: 'Aucune donnée étudiante disponible',
    noCourseDataAvailable: 'Aucune donnée de cours disponible',
    noSalesDataAvailable: 'Aucune donnée de ventes disponible',
  },

  common: {
    none: 'Aucun',
    noneF: 'Aucune',
    notSpecified: 'Non spécifié',
    notSpecifiedF: 'Non spécifiée',
    noDataAvailable: 'Aucune donnée disponible',
    noPaymentFound: 'Aucun paiement trouvé',
    noPaymentMatchCriteria: 'Aucun paiement ne correspond à vos critères de recherche.',
    noPaymentRecorded: 'Aucun paiement enregistré pour le moment.',
    noCourseFound: 'Aucun cours trouvé',
    noTrainerFound: 'Aucun formateur trouvé',
    noRoomFound: 'Aucune salle trouvée',
    noStudentFound: 'Aucun étudiant trouvé',
    noEvaluationFound: 'Aucune évaluation trouvée',
    noSessionFound: 'Aucune session trouvée',
    noGroupFound: 'Aucun groupe trouvé',
    noNotification: 'Aucune notification',
    noNotificationMatchCriteria: 'Aucune notification ne correspond aux critères sélectionnés.',
    noNewNotification: 'Aucune nouvelle notification',
    noUnreadNotification: 'Aucune notification non lue',
    noPlanSelected: 'Aucun plan sélectionné',
    noPlan: 'Aucun plan',
    noBioAvailable: 'Aucune biographie disponible',
    noExpense: 'Aucune dépense',
    noExpenseThisMonth: 'Aucune dépense ce mois',
    noResourceAdded: 'Aucune ressource ajoutée',
    noResourceAvailable: 'Aucune ressource disponible',
    noResourceDescription: 'Aucune ressource pédagogique n\'a été ajoutée à cette session.',
    noStudentEnrolledSession: 'Aucun étudiant n\'est inscrit à cette session de formation.',
    noActiveSubscription: 'Aucun abonnement actif',
    noSubscriptionFound: 'Aucun abonnement trouvé',
    noSubscriptionMatchCriteria: 'Aucun abonnement ne correspond à vos critères de recherche.',
    noActiveSubscriptionNow: 'Aucun abonnement actif pour le moment.',
    noProgramAssigned: 'Aucun programme assigné',
    noCoachFound: 'Aucun coach trouvé',
    noExerciseFound: 'Aucun exercice trouvé',
    noPlanFound: 'Aucun plan trouvé',
    noTemplateConfigured: 'Aucun template configuré',
    emailNotificationEnabled: 'Les notifications seront envoyées par email',
    emailNotificationDisabled: 'Aucune notification par email ne sera envoyée',
    smsNotificationEnabled: 'Les notifications urgentes seront envoyées par SMS',
    smsNotificationDisabled: 'Aucune notification par SMS ne sera envoyée',
    days: 'jours',
    selectedPlan: 'Plan sélectionné',
    duration: 'Durée',
    add: 'Ajouter',
    addExpense: 'Ajouter dépense',
    addTrainer: 'Ajouter un formateur',
    addCoach: 'Ajouter un coach',
    addExercise: 'Ajouter l\'exercice',
    addCategory: 'Ajouter une catégorie',
    addCourseType: 'Ajouter un type de cours',
    addEquipment: 'Ajouter un équipement',
    addMember: 'Ajouter un membre',
    addPlan: 'Ajouter un plan',
    addFeature: 'Ajouter une caractéristique',
    saveChanges: 'Enregistrer les modifications',
    print: 'Imprimer',
    exportPDF: 'Exporter PDF',
    exportExcel: 'Exporter Excel',
    printTitle: 'Imprimer',
    exportPDFTitle: 'Exporter en PDF',
    exportExcelTitle: 'Exporter en Excel',
    closeBtn: 'Fermer',
    confirmTitle: 'Confirmation',
    confirmBtn: 'Confirmer',
    cancelBtn: 'Annuler',
    update: 'Mettre à jour',
    create: 'Créer',
    search: 'Rechercher',
    searchPlaceholder: 'Rechercher...',
    paymentDetails: 'Détails du Paiement',
    amountDetails: 'Détails du Montant',
    editPayment: 'Modifier le Paiement',
    newPayment: 'Nouveau Paiement',
    editMember: 'Modifier le Membre',
    newMember: 'Nouveau Membre',
    updateMemberInfo: 'Mettre à jour les informations du membre',
    addNewMember: 'Ajouter un nouveau membre à la salle',
    updateBtn: 'Mettre à jour',
    createBtn: 'Créer',
    member: 'membre',
    editExercise: 'Modifier l\'exercice',
    newExercise: 'Nouvel exercice',
    editPlan: 'Modifier',
    newPlan: 'Créer',
    trainingSession: 'un plan d\'entraînement',
    thePlan: 'le plan',
    editCoach: 'Modifier le coach',
    newCoach: 'Ajouter un coach',
    updateCoach: 'Mettre à jour',
    addCoachBtn: 'Ajouter le coach',
    newTrainingSession: 'Nouvelle Session de Formation',
    editTrainingSession: 'Modifier la Session de Formation',
    createSession: 'Créer la session',
    updateSession: 'Mettre à jour',
    noProgramAssigned: 'Aucun programme assigné',
    editSubscription: 'Modifier',
    newSubscription: 'Créer',
    plan: 'un Plan',
    subscription: 'un Abonnement',
    theSubscription: 'l\'Abonnement',
    viewDetails: 'Voir les détails',
    sessionDetails: 'Détails de la séance',
    memberDetails: 'Détails du membre',
    notificationDetails: 'Détails de la notification',
    all: 'Voir toutes',
    unread: 'Voir non lues',
    paymentReceipt: 'Reçu Paiement',
  },
};
